var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSettingActiveIcon = function SvgSettingActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#setting-active-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.912 1.148c-.815-1.53-3.01-1.53-3.824 0l-.345.648a2.166 2.166 0 0 1-1.987 1.147l-.734-.025C1.29 2.858.192 4.758 1.11 6.23l.389.623a2.167 2.167 0 0 1 0 2.294l-.389.623c-.918 1.471.179 3.372 1.912 3.312l.734-.025a2.166 2.166 0 0 1 1.987 1.147l.345.648c.815 1.53 3.009 1.53 3.824 0l.345-.648a2.166 2.166 0 0 1 1.987-1.147l.734.025c1.733.06 2.83-1.84 1.912-3.312l-.389-.623a2.167 2.167 0 0 1 0-2.294l.389-.623c.918-1.471-.179-3.371-1.912-3.312l-.734.025a2.166 2.166 0 0 1-1.987-1.147l-.345-.648ZM8 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "setting-active-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

export default SvgSettingActiveIcon;